import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, Settings } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../auth";

export function ProfilePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  async function signOut() {
    await logout();
    navigate("/entrar", { replace: true });
  }

  async function submit(event: FormEvent) {
    event.preventDefault();
    setMessage("");
    await api("profile/password", { method: "PATCH", body: JSON.stringify({ password }) });
    setPassword("");
    setMessage(user?.login_username ? "PIN atualizado com sucesso." : "Senha atualizada com sucesso.");
  }

  return (
    <section>
      <div className="page-title"><div><h1>Meu perfil</h1><p>Dados da conta e segurança.</p></div></div>
      <div className="panel narrow">
        <p><b>Nome:</b> {user?.name}</p>
        {user?.login_username ? (
          <p><b>Usuário:</b> {user.login_username}</p>
        ) : (
          <p><b>E-mail:</b> {user?.email}</p>
        )}
        <p><b>Perfil:</b> {user?.role === "admin" ? "Administrador" : "Inspetor"}</p>

        {user?.role === "admin" && (
          <Link to="/admin" className="profile-admin-button">
            <Settings size={18} />
            <div>
              <strong>Administração</strong>
              <span>Usuários, checklists e auditoria</span>
            </div>
          </Link>
        )}

        <hr />
        <form onSubmit={submit}>
          {user?.login_username ? (
            <label>Novo PIN
              <input
                required
                type="password"
                inputMode="numeric"
                pattern="[0-9]{6}"
                minLength={6}
                maxLength={6}
                placeholder="6 dígitos"
                value={password}
                onChange={(e) => setPassword(e.target.value.replace(/\D/g, "").slice(0, 6))}
              />
            </label>
          ) : (
            <label>Nova senha
              <input
                required
                minLength={8}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          )}
          {message && <div className="alert">{message}</div>}
          <button className="primary">{user?.login_username ? "Alterar PIN" : "Alterar senha"}</button>
        </form>

        <div className="profile-logout-area">
          <button type="button" className="danger-outline profile-logout-button" onClick={signOut}>
            <LogOut size={18} /> Sair da conta
          </button>
          <small>Você voltará para a tela de login do MM Fleet.</small>
        </div>
      </div>
    </section>
  );
}
